
import React from 'react';
import { Navbar,Nav,Button,Form,FormControl } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import r from './img/img.png' ;
import reactLogo from './assets/logo.svg';
import {Card,CardDeck,Table } from 'react-bootstrap';
import Header from './header';
export  default class Tarification extends React.Component {
  
    render() {
      return (
          <div style={{backgroundColor:"#232b2b"}}>
<Header/>
    <div className="container" >
        <br/>
        <h1 style={{textAlign:"center",color:"white"}}>Une politique de prix simple et transparente
</h1><br/><br/>
 <CardDeck>
     <Card
text="white"
bg='info'    style={{ width: '18rem',textAlign:"center" }}
    className="mb-2"
  >
    <Card.Header style={{fontSize:"25px"}}>Gratuit</Card.Header>
    <Card.Body>
      <Card.Title> <strong>0.Da/mo</strong> </Card.Title>
      <Card.Text>
      Inscrivez-vous à l'abonnement standard
      </Card.Text>
      <Button variant="dark" style={{width:"140px",fontSize:"19px"}}>Choisir</Button><br/><br/>
      <Card.Text>La meilleure façon de découvrir le fonctionnement de flipsnack. Gratuit, sans engagement.</Card.Text>
    </Card.Body>
  </Card>

  <Card
text="white"
bg='info'    style={{ width: '18rem' ,textAlign:"center"}}
    className="mb-2"
  >
    <Card.Header style={{fontSize:"25px"}}>Starter</Card.Header>
    <Card.Body>
      <Card.Title><strong>1000.Da/mo</strong> </Card.Title>
      <Card.Text>
      Facture annuelle 12000.Da
      </Card.Text>
      <Button variant="dark" href="/payment" style={{width:"140px",fontSize:"19px"}}>Choisir</Button><br/><br/>
      <Card.Text>Une réponse simple à vos besoins d'édition. Parfait pour la publication et le partage.</Card.Text>
    </Card.Body>
  </Card><Card
    text="white"
        bg='info'
    style={{ width: '19rem' ,textAlign:"center"}}
    className="mb-2"
  >
    <Card.Header style={{fontSize:"25px"}}>Professionnel</Card.Header>
    <Card.Body>
      <Card.Title> <strong>2000.Da/mo </strong> </Card.Title>
      <Card.Text>
      Facture annuelle 24000.Da
      
      </Card.Text>
      <Button variant="dark" style={{width:"140px",fontSize:"19px"}}>Choisir</Button><br/><br/>
      <Card.Text>Prenez au sérieux la publication, la personnalisation et l'analyse de vos catalogues numériques.</Card.Text>
    </Card.Body>
  </Card>
 
  </CardDeck>
  <br/>  <br/>  <br/>
  <br/>


    </div>
    <div style={{backgroundColor:"white"}} >
        <br/>        <br/>
        <br/>

            <Table striped bordered hover style={{marginLeft:"200px",  width:"1200px"}} >
  <thead>
    <tr>
      <th>#</th>
      <th>Gratuit</th>
      <th>Starter</th>
      <th>Professionnel</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Nombre de catalogues</td>
      <td>Mark</td>
      <td>Otto</td>
      <td>@mdo</td>
    </tr>
    <tr>
      <td>Taille du catalogue</td>
      <td>Jacob</td>
      <td>Thornton</td>
      <td>@fat</td>
    </tr>
    <tr>
      <td>Nombre d'utilisateurs</td>
      <td colSpan="2">Larry the Bird</td>
      <td>@twitter</td>
    </tr>
    <tr>
      <td>Espaces de travail</td>
      <td colSpan="2">Larry the Bird</td>
      <td>@twitter</td>
    </tr>
  </tbody>
</Table>
<br/><br/>

   
    </div>
    <div style={{backgroundColor:"black"}}>
    <br/><br/>

<h2 style={{color:"white",textAlign:"center"}}>Créez votre folioscope digital personalisé en 60 secondes</h2>
<h4 style={{color:"white",textAlign:"center"}}>Essayez notre créateur de magasine en ligne gratuitement <br/><br/>
<Button variant="outline-info" style={{alignItems:"center"}}>Commencez des maintenant</Button>
</h4>
    
<br/><br/>
    </div>
    <footer className='footer mt-auto py-3 bg-light text-dark'>
        <div className='container'>Place sticky footer content here.</div>
      </footer>
          </div>

      )}}